import { createMobileBannerStore } from 'src/apps/mobile-common/stores/mobileBannerStore';
import {
	getMobileSdkBannerDismissCount,
	incrementMobileSdkBannerDismissCount,
	isMobileSdkBannerDismissed,
	resetMobileSdkBannerDismissCount,
	setMobileSdkBannerDismissed
} from 'src/common/services/api/LocalStorageApi';

export const useMobileSdkBannerStore = createMobileBannerStore({
	isBannerDismissed: isMobileSdkBannerDismissed,
	setBannerDismissed: setMobileSdkBannerDismissed,
	getDismissCount: getMobileSdkBannerDismissCount,
	incrementDismissCount: incrementMobileSdkBannerDismissCount,
	resetDismissCount: resetMobileSdkBannerDismissCount
});
